import React from 'react'

function Hr({item,title}:any) {
  return (
    <hr style={{
        margin: "10px 0",
        height: 3,
        backgroundColor: "blue",
        position: "absolute",
        top: item?.top,
        left: item?.left,
        width: item?.size,
        display: item?.show ? "" : "none",
    }}/>
  )
}

export default Hr